
export interface IfilterDispositivos {
    skip: number;
    take: number;
    search?: string | null;
}

export const filtroInicialDisp: IfilterDispositivos = {
    skip: 0,
    take: 50,
    search: "",
};